import type { TestimonialProps } from '@pflegia/ui/shared/testimonial';

import { EmployerLogo } from '../components/employers/Employers';
import { VideoObject } from '../components/how-it-works/HowItWorks';
import { OfferedValuesProps } from '../components/offered-values';
import { COMMON_QUESTIONS_AND_ANSWERS } from './guest-landing-page';

export const ADVANTAGES = ['range', 'socialMediaPresence', 'fees', 'smoothRunning'];

/**
 * Used for filenames and translation keys.
 */
export const PRACTICES = ['doctorOffice', 'dentalPractice', 'hospital', 'physioTherapy', 'occupationalTherapy', 'speechTherapist'];

export const SEARCH_FLOW_STEPS = ['selectYourFieldPraxia', 'pickTheBestJob', 'getJobInvites', '24hResponse'];

// TODO: when updating videos make sure to also update landingPage.json keys
export const TESTIMONIALS: Pick<TestimonialProps, 'name' | 'videoId'>[] = [
  {
    name: 'Hanna',
    videoId: 'cduYwKiqAVg',
  },
  {
    name: 'Helena',
    videoId: 'MnJqVZI5FNY',
  },
  {
    name: 'Max',
    videoId: 'QCVFslHLpkM',
  },
  {
    name: 'Magda',
    videoId: '4xW1XSjVVss',
  },
];

export const OFFERED_VALUES: OfferedValuesProps['values'] = [
  { key: 'effective', videoId: 'rmcT5Ph7SIM' },
  { key: 'informative', videoId: 'qZuZF71zyqw' },
  { key: 'convenient', videoId: 'vEViYlkCVYw' },
  { key: 'qualityPraxia', videoId: 'ezE_ot_hi6I' },
];

/**
 * heading and content values must match the keys in the translations file
 * under questionsAndAnswers section
 */
export const PRAXIA_FAQ: string[] = [...COMMON_QUESTIONS_AND_ANSWERS, 'praxiaHaveJobs'];

export const EMPLOYER_LOGOS_PRAXIA_SHARED: EmployerLogo[] = [
  { title: 'Paracelsus - Praxia', src: '/assets/employers/employer19.png' },
  { title: 'BG Klinik - Praxia', src: '/assets/employers/employer24.png' },
  { title: 'Schön Klinik - Praxia', src: '/assets/employers/employer4.png' },
];

export const EMPLOYER_LOGOS: EmployerLogo[] = [
  ...EMPLOYER_LOGOS_PRAXIA_SHARED,
  { title: 'Dialyse Zentrum Wurzburg - Praxia', src: '/assets/praxia-landing-page-employers/employer1.png' },
  { title: 'Dr. Phöbe Sfendonis - Praxia', src: '/assets/praxia-landing-page-employers/employer2.png' },
  { title: 'Helios - Praxia', src: '/assets/praxia-landing-page-employers/employer3.png' },
  { title: 'Dr. Med. Axel Schindler - Praxia', src: '/assets/praxia-landing-page-employers/employer4.png' },
  { title: 'Gemeinschaftspraxis Kaiserdamm - Praxia', src: '/assets/praxia-landing-page-employers/employer5.png' },
  { title: 'Apelos Therapie - Praxia', src: '/assets/praxia-landing-page-employers/employer30.png' },
  { title: 'Corius - Praxia', src: '/assets/praxia-landing-page-employers/employer31.png' },
  { title: 'RH Diagnostik und Therapie - Praxia', src: '/assets/praxia-landing-page-employers/employer32.png' },
  { title: 'Colosseum Dental Deutschland - Praxia', src: '/assets/praxia-landing-page-employers/employer33.png' },
  { title: 'Lasermed Augenarzt - Praxia', src: '/assets/praxia-landing-page-employers/employer34.png' },
  { title: 'Oyora - People in Health - Praxia', src: '/assets/praxia-landing-page-employers/employer35.png' },
  { title: 'Radprax - Praxia', src: '/assets/praxia-landing-page-employers/employer36.png' },
  { title: 'Sanoptis - Praxia', src: '/assets/praxia-landing-page-employers/employer37.png' },
  { title: 'Sana - Praxia', src: '/assets/praxia-landing-page-employers/employer38.png' },
  { title: 'Zahneins - Praxia', src: '/assets/praxia-landing-page-employers/employer39.png' },
];

// TODO: check for proper videos and thumbnails
export const HOW_IT_WORKS_VIDEO: VideoObject = { thumbnail: '/assets/video-thumbnails/KpSgznjpQhY.jpg', id: 'KpSgznjpQhY' };
